import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '485px',
    padding: 0,
  },
  timePeriodText: {
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px',
    },
    color: '#000000de',
  },
  bodyText: {
    [theme.breakpoints.only('xs')]: {
      fontSize: '14px',
    },
    color: '#0000008a',
  },
  iconWrapper: {
    color: 'rgba(0, 35, 75, 1)',
    backgroundColor: 'rgba(244, 246, 248, 1)',
    margin: '0 12px 0',
    width: '65px',
    height: '65px',
    [theme.breakpoints.down('xs')]: {
      width: '50px',
      height: '50px',
    },
  },
  componentSpacing: {
    marginTop: '1.25rem',
  },
  actions: {
    padding: '1.5rem',
  },
  closeButton: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    marginTop: '.75rem',
    marginRight: '.75rem',

    [theme.breakpoints.down('xs')]: {
      top: '-4px',
      right: '-4px',
    },

    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px',

      [theme.breakpoints.down('xs')]: {
        width: '20px',
        height: '20px',
      },
    },
  },
}))

export default useStyles
